import type { MessageKey, TranslationParams } from '../i18n';
import type { ToastMessage, ToastTone } from './types';

export interface ToastHostOptions {
  translate: (key: MessageKey, params?: TranslationParams) => string;
  onDismiss: (id: number) => void;
}

const toastIcons: Record<ToastTone, string> = {
  info: 'i',
  success: '✓',
  warning: '!',
  error: '×',
};

export function renderToasts(messages: ToastMessage[], options: ToastHostOptions): string {
  return `
    <div class="toast-host" role="region" aria-label="${options.translate('notifications')}" data-testid="toast-host">
      ${messages
        .map(
          (toast) => `
            <div class="toast toast--${toast.tone}" role="${toast.tone === 'error' ? 'alert' : 'status'}" data-toast-id="${toast.id}" data-testid="toast-${toast.tone}">
              <span class="status-icon" aria-hidden="true">${toastIcons[toast.tone]}</span>
              <span class="toast__message">${escapeHtml(toast.message)}</span>
              <button class="icon-button toast__dismiss" type="button" data-dismiss-toast="${toast.id}" aria-label="${options.translate('dismissed')}">×</button>
            </div>
          `,
        )
        .join('')}
    </div>
  `;
}

export function bindToasts(container: HTMLElement, options: ToastHostOptions): void {
  container.querySelectorAll<HTMLButtonElement>('[data-dismiss-toast]').forEach((button) => {
    button.addEventListener('click', () => options.onDismiss(Number(button.dataset.dismissToast)));
  });
}

function escapeHtml(value: string): string {
  const span = document.createElement('span');
  span.textContent = value;
  return span.innerHTML;
}
